module.exports = "data:image/gif;base64,R0lGODlhDAAMAIAAADMzAP///yH5BAAHAP8ALAAAAAAMAAwAAAIWhI+pGmHNHIzArTZpRnCfbiWTt5RLAQA7"